<template>
  <div>
    <div class="class-wrapper">
      <div class="class-item-img">
        <img
          v-if="gradeInfo.gradeCover"
          :src="concatImageUrl(gradeInfo.gradeCover, 260, 130)"
        />
        <span v-else>{{ gradeInfo.gradeName }}</span>
      </div>
      <div class="class-item-info">
        <p class="class-name">{{ gradeInfo.gradeName }}</p>
        <div class="class-info clearfix">
          <p>
            <b>课程数：</b>
            <span class="color1">{{ gradeInfo.courseCount }}</span>
          </p>
          <p>
            <b>最近考试：</b>
            {{ gradeInfo.examDate }}
          </p>
          <p>
            <b>待缴费：</b>
            <span class="color1">{{ gradeInfo.payItemCount }}</span>
          </p>
          <p>
            <b>{{ gradeInfo.courseName }}</b>
          </p>
        </div>
      </div>
      <div class="class-item-calandar">
        <div class="class-title">距离学习结束</div>
        <div class="class-text">
          还剩
          <span class="class-day">{{ gradeInfo.endDay }}</span
          >天
        </div>
      </div>
    </div>
    <div class="class-wrapper">
      <div class="teacher-avatar">
        <Avatar
          icon="ios-person"
          size="50"
          :src="concatImageUrl(gradeInfo.pic)"
        />
      </div>
      <div class="teacher-name">{{ gradeInfo.adminAccount }}</div>
      <!-- <div class="teacher-gender">
        <span class="female">
          <Icon type="md-female" size="20" />
        </span>
        <span class="male">
          <Icon type="md-male" size="18" />
        </span>
      </div>-->
      <div class="teacher-tel">{{ gradeInfo.mobile }}</div>
      <div class="teacher-text">班主任老师</div>
    </div>

    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="tabIndex == 0 ? 'active' : ''" @click="changeTab(0)">
          专业课程
        </li>
        <li :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">
          我的缴费
        </li>
        <li :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">
          学籍档案
        </li>
        <li :class="tabIndex == 3 ? 'active' : ''" @click="changeTab(3)">
          考试成绩
        </li>
        <li :class="tabIndex == 4 ? 'active' : ''" @click="changeTab(4)">
          我的毕业
        </li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="major-course" v-show="tabIndex == 0">
        <dl
          class="course-collapse"
          v-for="(item, index) in courseList"
          :key="index"
        >
          <dt class="collapse-header">
            <div class="collapse-header-info">
              <span class="header-info-icon">
                <img src="../../assets/images/class-teach.png" />
              </span>
              <span class="header-info-name">{{ item.courseName }}</span>
              <span class="header-info-book" @click="viewTextbook(item)"
                >【查看教材】</span
              >
              <div class="header-info-time">
                考试时间：
                <span
                  v-for="(time, timeIndex) in item.courseExamtimeList"
                  :key="timeIndex"
                  style="margin-right: 10px"
                  >{{ time.ExamDate }} {{ time.startTime }}</span
                >
              </div>
            </div>
            <div
              @click="showAndHideCollapse(item)"
              class="collapse-header-icon"
              :class="{ active: item.contentVisible }"
            >
              <Icon type="ios-arrow-dropup" size="20" />
            </div>
          </dt>
          <dd class="collapse-body" :class="{ active: item.contentVisible }">
            <div class="collapse-content" v-if="item.courseIntro">
              {{ item.courseIntro }}
            </div>
            <div class="collapse-content" style="text-align: center" v-else>
              暂无介绍
            </div>
          </dd>
        </dl>
      </div>
      <div v-show="tabIndex == 1">
        <div class="sub-tab-action">
          <button
            class="tab-action-btn"
            :class="{ active: feeIndex == 0 }"
            @click="changeFee(0)"
          >
            待缴费
          </button>
          <button
            class="tab-action-btn"
            :class="{ active: feeIndex == 1 }"
            @click="changeFee(1)"
          >
            已缴费
          </button>
        </div>
        <div class="pay-fees-body">
          <Table :columns="feeColums" :data="filterFeeList">
            <template slot-scope="{ row }" slot="money">
              <span>{{ row.Cost }}</span>
              <p v-if="row.isDebt == 1 && feeIndex == 1" style="color: red">
                (含欠费)
              </p>
              <p
                v-if="row.favourableAmount && feeIndex == 1"
                style="color: red"
              >
                {{ row.favourableAmount }}
              </p>
            </template>
            <template slot-scope="{ row }" slot="action">
              <Button
                v-if="row.status == 1"
                type="primary"
                shape="circle"
                size="small"
                @click="payItem(row)"
                >立即缴费</Button
              >
              <div v-else-if="row.status == 2" class="fee-item-expired">
                <span>过期未缴</span>
                <Tooltip
                  content="过期未缴费项目，请线下联系班主任老师~~"
                  placement="left"
                >
                  <Icon type="ios-alert-outline" size="20" />
                </Tooltip>
              </div>
              <div v-else-if="row.status == 3" class="fee-item-audit">
                待审核
              </div>
              <div v-else class="fee-item-success">缴费成功</div>
            </template>
          </Table>
        </div>
      </div>
      <class-school-roll
        v-if="tabIndex == 2"
        :gradeInfo="gradeInfo"
      ></class-school-roll>
      <div v-if="tabIndex == 3">
        <div class="sub-tab-action clearfix">
          <button
            class="tab-action-btn"
            :class="{ active: examTabIndex == 0 }"
            @click="examTabIndex = 0"
          >
            我的成绩
          </button>
          <button
            class="tab-action-btn"
            :class="{ active: examTabIndex == 1 }"
            @click="examTabIndex = 1"
          >
            我的考试
          </button>
          <div class="exam-action" v-if="isAllowEnroll && examTabIndex == 1">
            <Button type="primary" @click="addEnroll()">我要报考</Button>
          </div>
        </div>
        <class-score
          v-if="examTabIndex == 0"
          :gradeInfo="gradeInfo"
        ></class-score>
        <div v-show="examTabIndex == 1">
          <div class="no-data" v-show="examList.length === 0">
            <img src="../../assets/images/v3/no-data.png" />
            <p>暂无报考信息</p>
          </div>
          <dl
            class="course-collapse exam-list"
            v-for="(item, index) in examList"
            :key="index"
          >
            <dt class="collapse-header" @click="showAndHideExam(item)">
              <div class="collapse-header-info clearfix">
                <div class="exam-name">{{ item.pmname }}</div>
                <div class="exam-status">
                  <span v-if="item.status == 1">待审核</span>
                  <span v-if="item.status == 2">待缴费</span>
                  <span v-if="item.status == 3">报考成功</span>
                  <span v-if="item.status == 4">报考失败</span>
                </div>
              </div>
              <div
                class="collapse-header-icon"
                :class="{ active: item.contentVisible }"
              >
                <Icon type="ios-arrow-dropup" size="20" />
              </div>
            </dt>
            <dd class="collapse-body" :class="{ active: item.contentVisible }">
              <div class="exam-item-action clearfix">
                <div class="exam-item-name">考试课程</div>
                <div class="exam-item-btn" v-show="item.status === 1">
                  <Button type="warning" size="small" @click="editEnroll(item)"
                    >修改报考</Button
                  >
                </div>
              </div>
              <div class="exam-item-list">
                <Table
                  :columns="examColumns"
                  size="small"
                  border
                  :data="item.courseExamTimes"
                ></Table>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <class-graduate
        v-if="tabIndex == 4"
        :gradeInfo="gradeInfo"
      ></class-graduate>
    </div>
    <Modal v-model="textbookVisible" title="课程教材" width="600" footer-hide>
      <Table
        :columns="textbookColumns"
        size="small"
        border
        :data="textbookList"
      ></Table>
    </Modal>
    <Modal v-model="payCodeVisible" title="扫码付款" width="380" footer-hide>
      <div class="payment-qrcode">
        <div class="payment-qrcode-box">
          <p>扫一扫，向我付款</p>
          <p>
            <vue-qr
              :margin="10"
              :size="220"
              :correctLevel="3"
              :text="payQrcodeUrl"
            ></vue-qr>
          </p>
        </div>
        <div class="payment-qrcode-logo">
          <img
            src="../../assets/images/pay-logo-union-wa.png"
            width="346"
            height="67"
          />
          <p>请使用微信或支付宝扫码支付</p>
        </div>
      </div>
    </Modal>
    <Modal
      v-model="examModelVisible"
      title="我要报考"
      size="small"
      width="1000"
    >
      <Row :gutter="10" type="flex" align="middle">
        <i-col span="3" style="text-align: right">报考考期：</i-col>
        <i-col span="21">
          <template v-if="examAction === 0">
            <Select
              v-model="examTerm"
              @on-change="getExamCourseList"
              style="width: 200px"
            >
              <Option
                v-for="item in examTermList"
                :value="item.id"
                :key="item.id"
                >{{ item.pmname }}</Option
              >
            </Select>
          </template>
          <template v-else>
            <span>{{ examCurrent.pmname }}</span>
          </template>
        </i-col>
      </Row>
      <Row :gutter="10" type="flex" align="middle" style="margin-top: 20px">
        <i-col span="3" style="text-align: right">选择课程：</i-col>
        <i-col span="21">
          <Select
            v-model="examCourseSelected"
            @on-change="changeExamCourse"
            placeholder="输入课程代码/课程名称"
            style="width: 200px"
            filterable
            clearable
          >
            <Option
              v-for="option in examCourseList"
              :value="option.id"
              :key="option.id"
            >
              {{ option.coursename }}
            </Option>
          </Select>
        </i-col>
      </Row>
      <Table
        :columns="examCourseCoulumns"
        size="small"
        border
        :data="examCourseSelectedList"
        style="margin-top: 20px"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="error" size="small" @click="cancelSelected(row)"
            >取消选择</Button
          >
        </template>
      </Table>
      <div style="padding: 10px 0">
        <span>报考课程数：{{ examCourseSelectedList.length }}</span>
        <span style="margin-left: 50px"
          >合计报考费用：￥{{ enrollFee.toFixed(2) }}</span
        >
        <span
          v-if="
            this.examTermCurrent &&
            Object.keys(this.examTermCurrent).length > 0 &&
            !this.examTermCurrent.istake
          "
          style="color: #19be6b"
        >
          (本期不收费)
        </span>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="default" @click="examModelVisible = false">取消</Button>
        <Button type="success" style="margin-left: 20px" @click="enrollSubmit()"
          >确定报考</Button
        >
      </div>
    </Modal>

    <!-- 缴费提示弹窗 -->
    <Modal
      v-model="payModelVisible"
      :closable="false"
      :mask-closable="false"
      width="360"
      class-name="vertical-center-modal"
    >
      <p slot="header">
        <span>缴费提示</span>
      </p>
      <template v-if="payTipsType === 1">
        <p style="text-align: center">最后一步，缴纳报考费</p>
        <p style="text-align: center">就完成报考啦 ~</p>
      </template>
      <template v-else>
        <p style="text-align: center">已通过审核~</p>
        <p style="text-align: center">请尽快缴纳报考费</p>
      </template>

      <div slot="footer" style="text-align: center">
        <Button
          type="default"
          @click="payModelVisible = false"
          style="margin-right: 20px"
          >稍后再说</Button
        >
        <Button type="success" @click="enrollPayFee">现在缴费</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { user, study } from "../../request";
import VueQr from "vue-qr";

import ClassSchoolRoll from "../../components/member/ClassSchoolRoll";
import ClassScore from "../../components/member/ClassScore";
import ClassGraduate from "../../components/member/ClassGraduate";

export default {
  mixins: [siteMixin],
  data() {
    return {
      gradeCode: "",
      gradeInfo: {},
      tabIndex: 0,
      feeIndex: 0,
      courseList: [],
      textbookVisible: false,
      textbookColumns: [
        {
          title: "教材名称",
          key: "matName",
        },
        {
          title: "出版社",
          key: "pubName",
          width: 150,
        },
        {
          title: "版本",
          key: "pubNo",
          width: 120,
        },
        {
          title: "作者",
          key: "writer",
          width: 90,
          align: "center",
        },
      ],
      textbookList: [],
      feeColums: [
        {
          title: "项目",
          key: "payItemName",
          width: 110,
        },
        {
          title: "金额",
          slot: "money",
          width: 120,
        },
        {
          title: "类型",
          key: "paymentTypeName",
          width: 130,
        },
        {
          title: "期限",
          key: "paymentStartTime",
          width: 200,
        },
        {
          title: "说明",
          key: "memo",
        },
        {
          title: "操作",
          slot: "action",
          width: 120,
        },
      ],
      feeList: [],
      payOrderId: 0,
      payCodeVisible: false,
      payQrcodeUrl: "",
      examColumns: [
        { title: "课程名称", key: "courseName" },
        { title: "考试日期", key: "examDate", width: 160 },
        { title: "场次", key: "session", width: 120 },
        {
          title: "考试时间",
          width: 120,
          key: "startTime",
          render: (h, params) => {
            return h("span", [params.row.startTime, "~", params.row.endTime]);
          },
        },
      ],
      examTabIndex: 0,
      examList: [],
      examModelVisible: false,
      examCurrent: {},
      examAction: 0,
      examTerm: "",
      examTermList: [],
      examTermCurrent: {},
      examCourseCoulumns: [
        {
          title: "课程代码",
          key: "coursecode",
          width: 100,
        },
        {
          title: "课程名称",
          key: "coursename",
        },
        {
          title: "考试日期",
          key: "examdate",
          width: 100,
        },
        {
          title: "场次",
          key: "session",
          width: 62,
        },
        {
          title: "考试时间",
          key: "starttime",
          width: 110,
          render: (h, params) => {
            return h("span", [params.row.starttime, "~", params.row.endtime]);
          },
        },
        {
          title: "费用",
          key: "fee",
          width: 70,
        },
        {
          title: "操作",
          slot: "action",
          width: 100,
          align: "center",
        },
      ],
      examCourseList: [],
      examCourseSelected: "",
      examCourseSelectedList: [],
      payTipsType: 1, //无需审核直接付费payTipsType=1,审核后付费payTipsType=2
      payModelVisible: false,
      isAllowEnroll: false,
    };
  },
  computed: {
    filterFeeList() {
      if (this.feeIndex == 0) {
        return this.feeList.filter((m) => m.status == 1 || m.status == 2);
      } else {
        return this.feeList.filter((m) => m.status == 3 || m.status == 4);
      }
    },
    enrollFee() {
      if (
        this.examTermCurrent &&
        Object.keys(this.examTermCurrent).length > 0
      ) {
        if (this.examTermCurrent.istake === 0) {
          return 0;
        }
      }
      if (
        this.examCourseSelectedList &&
        this.examCourseSelectedList.length > 0
      ) {
        return this.examCourseSelectedList.reduce((total, current) => {
          return total + current.fee;
        }, 0);
      } else {
        return 0;
      }
    },
  },
  mounted() {
    if (!this.initParams()) return;
    this.getClassInfo();
    this.getCourseList();
  },
  methods: {
    initParams() {
      let code = this.$route.params.id;
      if (code) {
        this.gradeCode = code;
        return true;
      } else {
        this.$Message.error("参数错误");
        return false;
      }
    },
    getClassInfo() {
      user.getClassInfo(this.gradeCode, this.loginUser.userId).then((res) => {
        //console.log("classInfo", res);
        if (res.status === 1) {
          this.gradeInfo = res.data;
          this.gradeInfo.gradeCode = this.gradeCode;
        }
      });
    },
    getCourseList() {
      user
        .getClassCourseList(this.gradeCode, this.loginUser.userId)
        .then((res) => {
          //console.log("classCourseList", res);
          if (res.status === 1) {
            this.courseList = res.data;
            this.courseList.forEach((item) => {
              this.$set(item, "contentVisible", false);
            });
          }
        });
    },
    viewTextbook(item) {
      //console.log(item);
      user.getClassTextbook(item.courseId).then((res) => {
        //console.log("textbook", res);
        if (res.status === 1) {
          this.textbookList = res.data;
          this.textbookVisible = true;
        }
      });
    },
    getPayItem() {
      user
        .getClassPayItem(this.gradeCode, this.loginUser.userId)
        .then((res) => {
          //console.log("payItem", res);
          if (res.status === 1) {
            this.feeList = res.data;
          }
        });
    },
    payItem(item) {
      //console.log(item);
      if (item.type === 2) {
        this.examCurrent = { id: item.Id };
        this.enrollPayFee();
        return;
      }
      user
        .reqItemPay(
          item.AgencyId,
          item.Id,
          this.loginUser.userId,
          //1343153,
          this.gradeCode
        )
        .then((res) => {
          console.log("payItem", res);
          if (res.status === 1) {
            this.payOrderId = res.data.orderId;
            this.payQrcodeUrl = res.data.code_url;
            this.payCodeVisible = true;
            this.getIsPaySuccess(this.getPayItem);
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    getIsPaySuccess(callback) {
      if (this.payOrderId > 0) {
        let timer = setInterval(() => {
          user.getIsPaySuccess(this.payOrderId).then((res) => {
            //console.log("paySuccess", res);
            if (res.status === 1) {
              if (res.data == 1) {
                clearInterval(timer);
                this.payCodeVisible = false;
                this.$Message.success("已付款成功！");
                if (callback) {
                  callback();
                }
              }
            }
          });
        }, 2000);
      }
    },
    showAndHideCollapse(item) {
      item.contentVisible = !item.contentVisible;
    },
    changeFee(index) {
      this.feeIndex = index;
    },
    getExamList() {
      const srfId = this.gradeInfo.srfId || 0;
      user.getExamList(srfId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.examList = res.data;
          this.examList.forEach((item, index) => {
            if (index === 0) {
              this.$set(item, "contentVisible", true);
            } else {
              this.$set(item, "contentVisible", false);
            }
          });
          this.setExamToPay();
        }
      });
    },
    //有审核通过的报考要进行付费
    setExamToPay() {
      const payExam = this.examList.find(
        (m) => m.status === 2 && m.isNotice === 0
      );
      if (payExam) {
        this.examCurrent = payExam;
        this.payTipsType = 2;
        this.payModelVisible = true;
        user.setExamForIsNotice(this.examCurrent.id).then((res) => {
          if (res.status === 1) {
            console.log("ok");
          }
        });
      }
    },
    //显示隐藏报考课程信息
    showAndHideExam(item) {
      item.contentVisible = !item.contentVisible;
      if (item.contentVisible == false) return;
      user.getExamCourseList(item.id).then((res) => {
        console.log(res);
        if (res.status === 1) {
          this.$set(item, "courseExamTimes", res.data);
        }
      });
    },
    getIsAllowEnroll() {
      const srfId = this.gradeInfo.srfId || 0;
      user.getIsEnroll(srfId).then((res) => {
        if (res.status === 1) {
          this.isAllowEnroll = res.data === 1;
        }
      });
    },
    //我要报考
    addEnroll() {
      this.examAction = 0;
      this.examModelVisible = true;
      this.initExamModalInfo();
      this.getExamTermList();
    },
    //修改报考
    editEnroll(item) {
      this.examAction = 1;
      this.examModelVisible = true;
      this.examCurrent = item;
      this.examTerm = item.pmid;
      this.getExamTermList();
      this.getExamCourseList(item.pmid);
    },
    initExamModalInfo() {
      this.examTerm = "";
      this.examTermList = [];
      this.examTermCurrent = {};
      this.examCourseList = [];
      this.examCourseSelectedList = [];
      this.examCurrent = {};
    },
    getExamTermList() {
      const srfId = this.gradeInfo.srfId || 0;
      user.getExamTermList(srfId).then((res) => {
        console.log("examTerm", res);
        if (res.status === 1) {
          this.examTermList = res.data;
          if (this.examTerm) {
            this.examTermCurrent = this.examTermList.find(
              (m) => m.id === this.examTerm
            );
          }
        }
      });
    },
    getExamCourseList(value) {
      this.examCourseSelected = "";
      this.examCourseSelectedList = [];
      const srfId = this.gradeInfo.srfId || 0;
      if (!value) return;
      this.examTermCurrent = this.examTermList.find((m) => m.id === value);
      user.getExamTermCourseList(srfId, value).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.examCourseList = res.data;
          if (this.examAction === 1) {
            this.setExamCourseSelectedList();
          }
        }
      });
    },
    setExamCourseSelectedList() {
      const selectedCourse = `,${this.examCurrent.subject},`;
      this.examCourseSelectedList = this.examCourseList.filter(
        (m) => selectedCourse.indexOf(m.id) > -1
      );
    },
    changeExamCourse(value) {
      if (!value) return;
      const result = this.examCourseList.find((m) => m.id === value);
      if (result && this.examCourseSelectedList.indexOf(result) < 0) {
        this.examCourseSelectedList.push(result);
      }
      setTimeout(() => {
        this.examCourseSelected = "";
      }, 100);
    },
    cancelSelected(row) {
      console.log(row);
      const item = this.examCourseSelectedList.find((m) => m.id === row.id);
      const index = this.examCourseSelectedList.indexOf(item);
      this.examCourseSelectedList.splice(index, 1);
    },
    enrollSubmit() {
      const courseSet = this.examCourseSelectedList
        .map((item) => {
          return item.id;
        })
        .join(",");

      if (!courseSet) {
        this.$Message.error("请选择您要报考的课程");
        return;
      }

      //提效数据
      if (this.examAction === 0) {
        //添加
        //获取考期是否付需要付费和审核
        const isAudit = this.examTermCurrent.isaudit; // 是否需要审核
        const isTake = this.examTermCurrent.istake; //是否需要付款

        const data = {
          srfid: this.gradeInfo.srfId, //this.gradeInfo.srfId
          subject: courseSet, //课程ID集“,”分隔
          pmid: this.examTerm, //考期Id
          agencyid: this.siteConfig.agencyId,
        };

        user.addEnroll(data).then((res) => {
          console.log(res);
          if (res.status === 1) {
            const enrollFee = this.enrollFee; //临时存储报考费用

            this.getExamList();
            this.examModelVisible = false;
            this.initExamModalInfo();

            //需要审核时提示
            if (isAudit) {
              this.$Message.success("您已成功提交报考数据，请等待审核！");
              return;
            }

            if (!isTake || enrollFee === 0) {
              this.$Message.success("恭喜您，报考成功！");
              return;
            }

            //付费提示
            if (isTake) {
              this.examCurrent = { id: res.data };
              this.payTipsType = 1; //无需审核直接付费payTipsType=1,审核后付费payTipsType=2
              this.payModelVisible = true;
              return;
            }
            //不需要审核和付费，直接报考成功。
            this.$Message.success("恭喜您，报考成功！");
          } else {
            this.$Message.error(res.message);
          }
        });
      } else {
        //修改
        user
          .editEnroll({ id: this.examCurrent.id, subject: courseSet })
          .then((res) => {
            if (res.status === 1) {
              this.getExamList();
              this.examModelVisible = false;
              this.initExamModalInfo();
              this.$Message.success("修改报考信息成功！");
            } else {
              this.$Message.error(res.message);
            }
          });
      }
    },
    //报考缴费
    enrollPayFee() {
      if (!this.examCurrent) return;
      const id = this.examCurrent.id;
      user.enrollPaySave(id).then((res) => {
        //console.log(res);
        this.payModelVisible = false;
        if (res.status === 1) {
          this.changeTab(1); //切换到缴费页面
          this.payOrderId = res.data.orderId;
          this.payQrcodeUrl = res.data.code_url;
          this.payCodeVisible = true;
          this.getIsPaySuccess(this.getExamList);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //主Tab切换
    changeTab(index) {
      this.tabIndex = index;
      if (index === 1) {
        this.getPayItem();
      }
      if (index == 3) {
        this.getIsAllowEnroll();
        this.getExamList();
      }
    },
  },
  components: {
    VueQr,
    ClassSchoolRoll,
    ClassScore,
    ClassGraduate,
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";

.class-wrapper {
  display: flex;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  align-items: center;
  .class-item-img {
    display: flex;
    width: 260px;
    height: 130px;
    background-color: #41a5fd;
    color: #fff;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    overflow: hidden;
    img {
      width: 260px;
      height: 130px;
      border-radius: 10px;
    }
  }
  .class-item-info {
    flex: 1 1;
    padding-left: 20px;
    .class-name {
      font-size: 1.6rem;
      color: #333;
      font-weight: bold;
    }
    .class-info {
      margin-top: 10px;
      p {
        float: left;
        color: #666;
        font-size: 1.6rem;
        .ellipsis();
        padding: 5px 0;
        &:nth-child(2n + 1) {
          width: 30%;
        }
        &:nth-child(2n) {
          width: 60%;
        }
      }
    }
  }
  .class-item-calandar {
    width: 139px;
    height: 137px;
    background: url("../../assets/images/class-calendar.png") no-repeat;
    .class-title {
      color: #fff;
      text-align: center;
      margin-top: 0.8rem;
    }
    .class-text {
      margin-top: 2.6rem;
      text-align: center;
      .class-day {
        font-size: 3.2rem;
        color: #ff6600;
        font-weight: bold;
        margin: 0 2px;
      }
    }
  }
  .teacher-avatar {
    width: 50px;
    height: 50px;
    margin: -10px 0;
  }
  .teacher-name {
    margin-left: 20px;
    font-weight: bold;
  }
  .teacher-gender {
    margin-left: 2px;
    .female {
      color: #ff4f4f;
      transform: rotate(45deg);
      display: inline-block;
    }
    .male {
      display: inline-block;
      color: #41a5fd;
    }
  }
  .teacher-tel,
  .teacher-text {
    font-weight: bold;
    margin-left: 60px;
  }
}

.member-main-body{
  padding: 20px;
}

.course-collapse {
  width: 100%;
  .collapse-header {
    display: flex;
    align-items: center;
    .collapse-header-info {
      flex: 1;
      span {
        .inline-block();
        &.header-info-name {
          font-size: 1.5rem;
          font-weight: bold;
          margin-left: 10px;
        }
        &.header-info-book {
          margin-left: 10px;
          color: #2097d5;
          cursor: pointer;
        }
      }
      .header-info-time {
        color: #666;
      }
    }
    .collapse-header-icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: all 0.2s linear;
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .collapse-body {
    max-height: 0;
    overflow: hidden;
    background: #eee;
    margin: 10px auto;
    transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
    &.active {
      transition: max-height 0.8s ease-in-out;
      max-height: 1000px;
    }
    .collapse-content {
      padding: 10px;
    }
  }
}
.sub-tab-action {
  margin-bottom: 20px;
  .tab-action-btn {
    border: none;
    outline: none;
    height: 32px;
    padding: 5px 20px;
    margin-right: 20px;
    background: #fff;
    box-shadow: 1px 1px 3px #ccc;
    border-radius: 5px;
    cursor: pointer;
    &.active,
    &:hover {
      color: #fff;
      background: #0e90d2;
    }
  }
}
.pay-fees-body {
  .fee-item-expired {
    span {
      .inline-block();
      margin-right: 5px;
    }
    i {
      color: crimson;
      vertical-align: -0.26em;
    }
  }
  .fee-item-audit {
    color: orangered;
  }
  .fee-item-success {
    color: #999;
  }
}
// 支付弹窗
.payment-qrcode {
  // margin-top: 1rem;
  .payment-qrcode-box {
    width: 350px;
    height: 350px;
    background-color: #0f5796;
    margin: 0 auto;
    p {
      text-align: center;
      &:first-child {
        font-size: 20px;
        color: #fff;
        padding-top: 20px;
      }
      &:last-child {
        margin: 25px auto 0 auto;
        width: 220px;
        height: 220px;
        border-radius: 10px;
        overflow: hidden;
        background: #fff;
        position: relative;
        span {
          position: absolute;
          left: 0;
          top: 0;
          width: 220px;
          height: 220px;
          z-index: 2;
        }
      }
    }
  }
  .payment-qrcode-logo {
    margin-top: 1.6rem;
    text-align: center;
    img {
      display: inline-block;
      height: 60px;
    }
    p {
      font-size: 22px;
      text-align: center;
      color: #135997;
      margin-top: 15px;
    }
  }
}
// 报考
.exam-action {
  float: right;
  text-align: right;
}
.exam-list {
  border-bottom: 1px solid #eee;
  .collapse-header {
    padding-top: 20px;
  }
  .exam-name {
    float: left;
    font-size: 1.6rem;
    font-weight: bold;
  }
  .exam-status {
    float: right;
    color: #929292;
    margin-right: 10px;
    padding: 4px;
  }
  .exam-item-action {
    // background: #fff;
    // padding-bottom: 10px;
    padding: 10px;
    .exam-item-name {
      float: left;
      font-weight: bold;
      height: 24px;
      line-height: 24px;
      font-size: 1.5rem;
    }
    .exam-item-btn {
      float: right;
    }
  }
  .exam-item-list {
    padding: 10px;
  }
}
/deep/.ivu-tooltip-inner {
  max-width: 300px !important;
}
</style>